import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["wrapperStyle", "iconStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useState, useEffect, useCallback } from 'react';
import { getCountryCallingCode, isValidPhoneNumber as validatePhoneNumber } from 'react-phone-number-input';
import CountriesMenu from '../countries-menu';
import { TextInput } from '../text-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PhoneInput(_ref) {
  var textInput = _ref.textInput,
      countriesMenu = _ref.countriesMenu,
      onChange = _ref.onChange,
      id = _ref.id,
      _ref$defaultCountry = _ref.defaultCountry,
      defaultCountry = _ref$defaultCountry === void 0 ? 'IT' : _ref$defaultCountry,
      value = _ref.value;

  var _ref2 = countriesMenu || {},
      countryMenuWrapperStyle = _ref2.wrapperStyle,
      favorites = _ref2.favorites;

  var _ref3 = textInput || {},
      inputWrapperStyles = _ref3.wrapperStyle,
      iconStyle = _ref3.iconStyle,
      restInputProps = _objectWithoutProperties(_ref3, _excluded);

  var _useState = useState(''),
      phoneNumber = _useState[0],
      setPhoneNumber = _useState[1];

  var _useState2 = useState(defaultCountry),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1]; // Helper to remove spaces


  var removeSpaces = useCallback(function (str) {
    return str.replace(/\s+/g, '');
  }, []); // Helper to format phone number

  var formatPhoneNumber = useCallback(function (num) {
    if (num.length > 3 && num[3] !== ' ') {
      return num.slice(0, 3) + ' ' + num.slice(3);
    }

    return num;
  }, []); // Set initial phone number from value

  useEffect(function () {
    if (value) {
      if (value.startsWith('+')) {
        setPhoneNumber(value.replace(value.slice(0, 3), ''));
      } else {
        setPhoneNumber("+".concat(getCountryCallingCode(selectedCountry)).concat(removeSpaces(value)));
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []); // Notify parent on change

  useEffect(function () {
    if (onChange) {
      if (phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.startsWith('+')) {
        onChange(phoneNumber);
      } else {
        onChange("+".concat(getCountryCallingCode(selectedCountry)).concat(removeSpaces(phoneNumber)));
      }
    }
  }, [onChange, phoneNumber, selectedCountry, removeSpaces]); // Handle country change

  var handleCountryChange = useCallback(function (country) {
    return setSelectedCountry(country);
  }, []); // Handle input change

  var handleInputChange = useCallback(function (phone) {
    return setPhoneNumber(function (prev) {
      return isNaN(+removeSpaces(phone)) ? prev : phone;
    });
  }, [removeSpaces]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    fullwidth: textInput === null || textInput === void 0 ? void 0 : textInput.isFullwidth,
    children: [/*#__PURE__*/_jsx(CountriesMenu, {
      value: selectedCountry,
      onChange: handleCountryChange,
      wrapperStyle: [{
        "position": "absolute",
        "top": "8px",
        "left": "0.75rem",
        "zIndex": "10"
      }, countryMenuWrapperStyle || {}],
      variant: "phone",
      favorites: favorites,
      dropdownPlacementConfig: {
        crossAxis: -8,
        mainAxis: 8
      }
    }), /*#__PURE__*/_jsx(TextInput, _objectSpread({
      id: id,
      type: "tel",
      iconStyle: [{
        "position": "relative",
        "left": "68px"
      }, iconStyle || {}],
      inputStyle: textInput !== null && textInput !== void 0 && textInput.icon ? {
        "paddingLeft": "100px"
      } : {
        "paddingLeft": "78px"
      },
      value: formatPhoneNumber(phoneNumber),
      onChange: handleInputChange
    }, restInputProps))]
  });
}
export default PhoneInput;
export function checkIsPhoneNumberValid(phoneNumber) {
  if (!phoneNumber) return false;
  return validatePhoneNumber(phoneNumber);
}

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "phone-input__Wrapper",
  componentId: "sc-4rhery-0"
})(["", " ", ""], {
  "position": "relative",
  "width": "fit-content"
}, function (_ref4) {
  var fullwidth = _ref4.fullwidth;
  return fullwidth ? {
    "width": "100%"
  } : {};
});